<template>
  <el-dialog :title="$t('addAttendanceClasses.title')" :visible.sync="visible" width="60%" @close="closeDialog">
    <el-form ref="form" :model="formData" :rules="rules" label-width="150px" label-position="right">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('addAttendanceClasses.classesName')" prop="classesName">
            <el-input v-model="formData.classesName" :placeholder="$t('addAttendanceClasses.classesNamePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('addAttendanceClasses.timeOffset')" prop="timeOffset">
            <el-input v-model="formData.timeOffset" type="number"
              :placeholder="$t('addAttendanceClasses.timeOffsetPlaceholder')">
              <template slot="append">{{ $t('attendanceClassesManage.minute') }}</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('addAttendanceClasses.lateOffset')" prop="lateOffset">
            <el-input v-model="formData.lateOffset" type="number"
              :placeholder="$t('addAttendanceClasses.lateOffsetPlaceholder')">
              <template slot="append">{{ $t('attendanceClassesManage.minute') }}</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('addAttendanceClasses.leaveOffset')" prop="leaveOffset">
            <el-input v-model="formData.leaveOffset" type="number"
              :placeholder="$t('addAttendanceClasses.leaveOffsetPlaceholder')">
              <template slot="append">{{ $t('attendanceClassesManage.minute') }}</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('addAttendanceClasses.maxLastOffset')" prop="maxLastOffset">
            <el-input v-model="formData.maxLastOffset" type="number"
              :placeholder="$t('addAttendanceClasses.maxLastOffsetPlaceholder')">
              <template slot="append">{{ $t('attendanceClassesManage.minute') }}</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 电子围栏设置 -->
      <el-divider content-position="left">电子围栏设置</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="启用电子围栏">
            <el-switch
              v-model="formData.locationType"
              active-value="Y"
              inactive-value="N"
              @change="onLocationTypeChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formData.locationType === 'Y'">
          <el-form-item label="允许打卡距离" prop="locationDistance">
            <el-input v-model="formData.locationDistance" type="number" placeholder="请输入距离">
              <template slot="append">米</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 地图选择（当启用电子围栏时显示） -->
      <el-row v-if="formData.locationType === 'Y'">
        <el-col :span="24">
          <el-form-item label="打卡地点">
            <div class="map-container">
              <select-map-pos ref="selectMapPos" @position-change="onMapPositionChange" />
            </div>
            <div class="coord-info" v-if="formData.latitude && formData.longitude">
              坐标：{{ formData.latitude }}, {{ formData.longitude }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 拍照打卡设置 -->
      <el-divider content-position="left">打卡方式设置</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="启用拍照打卡">
            <el-switch
              v-model="formData.photoType"
              active-value="Y"
              inactive-value="N"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveAttendanceClassesInfo">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveAttendanceClasses } from '@/api/oa/attendanceClassesManageApi'
import { getCommunityId } from '@/api/community/communityApi'
import SelectMapPos from '@/components/inspection/selectMapPos'

export default {
  name: 'AddAttendanceClasses',
  components: {
    SelectMapPos
  },
  data() {
    return {
      visible: false,
      formData: {
        classesId: '',
        classesName: '',
        timeOffset: '',
        leaveOffset: '',
        lateOffset: '',
        classesObjType: '',
        classesObjId: '',
        classesObjName: '',
        maxLastOffset: '',
        communityId: '',
        // 电子围栏相关字段
        locationType: 'N',
        latitude: '',
        longitude: '',
        locationDistance: '',
        // 拍照打卡
        photoType: 'N'
      },
      rules: {
        classesName: [
          { required: true, message: this.$t('addAttendanceClasses.classesNameRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('addAttendanceClasses.classesNameMaxLength'), trigger: 'blur' }
        ],
        timeOffset: [
          { required: true, message: this.$t('addAttendanceClasses.timeOffsetRequired'), trigger: 'blur' },
        ],
        lateOffset: [
          { required: true, message: this.$t('addAttendanceClasses.lateOffsetRequired'), trigger: 'blur' },
          { max: 20, message: this.$t('addAttendanceClasses.lateOffsetMaxLength'), trigger: 'blur' }
        ],
        leaveOffset: [
          { required: true, message: this.$t('addAttendanceClasses.leaveOffsetRequired'), trigger: 'blur' },
          { max: 20, message: this.$t('addAttendanceClasses.leaveOffsetMaxLength'), trigger: 'blur' }
        ],
        maxLastOffset: [
          { required: true, message: this.$t('addAttendanceClasses.maxLastOffsetRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    // 监听电子围栏开关：仅当从 N 切到 Y（地图组件被 v-if 创建出来）时初始化地图，
    // 避免在 open() 中过早执行导致 this.$refs.selectMapPos 还未挂载
    'formData.locationType'(newVal, oldVal) {
      if (newVal === 'Y' && oldVal !== 'Y') {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.selectMapPos && !this.$refs.selectMapPos.map) {
              const mapData = {}
              if (this.formData.latitude && this.formData.longitude) {
                mapData.lat = this.formData.latitude
                mapData.lng = this.formData.longitude
              }
              this.$refs.selectMapPos.initMap(mapData)
            }
          }, 300)
        })
      }
    }
  },
  methods: {
    open(params) {
      this.formData = {
        ...this.formData,
        ...params,
        communityId: getCommunityId(),
        locationType: params && params.locationType ? params.locationType : 'N',
        latitude: params && params.latitude ? params.latitude : '',
        longitude: params && params.longitude ? params.longitude : '',
        locationDistance: params && params.locationDistance ? params.locationDistance : '',
        photoType: params && params.photoType ? params.photoType : 'N'
      }
      this.visible = true
      // 地图初始化移至 watch('formData.locationType') 中，确保 v-if 切换为 Y 时再创建地图实例
      // 兜底：若 open 时 locationType 已是 Y（外部传参场景），也尝试初始化一次
      this.$nextTick(() => {
        if (this.formData.locationType === 'Y') {
          setTimeout(() => {
            if (this.$refs.selectMapPos && !this.$refs.selectMapPos.map) {
              const mapData = {}
              if (this.formData.latitude && this.formData.longitude) {
                mapData.lat = this.formData.latitude
                mapData.lng = this.formData.longitude
              }
              this.$refs.selectMapPos.initMap(mapData)
            }
          }, 300)
        }
      })
    },
    onLocationTypeChange(val) {
      if (val === 'N') {
        this.formData.latitude = ''
        this.formData.longitude = ''
        this.formData.locationDistance = ''
      }
    },
    onMapPositionChange(data) {
      this.formData.latitude = data.lat
      this.formData.longitude = data.lng
    },
    closeDialog() {
      this.visible = false
      this.$refs.form.resetFields()
    },
    async saveAttendanceClassesInfo() {
      try {
        await this.$refs.form.validate()
        // 如果启用电子围栏但未设置位置，提示错误
        if (this.formData.locationType === 'Y' && (!this.formData.latitude || !this.formData.longitude)) {
          this.$message.error('请在地图上选择打卡位置')
          return
        }
        const response = await saveAttendanceClasses(this.formData)
        if (response.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.$emit('success')
          this.closeDialog()
        } else {
          this.$message.error(response.msg)
        }
      } catch (error) {
        console.error('保存失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}
.coord-info {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
</style>